export default __webpack_public_path__ + "static/media/blastSlide1.fbbf3651.png";